
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

@Component({
  name: "LoaderContainer",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
})
export default class LoaderContainer extends Vue {
  @Watch("value")
  onValueChanged(value: any) {
    document.documentElement.style.overflow = value ? "hidden" : "auto";
  }
}
